import { Box } from '@mui/system';
import { Typography } from '@mui/material';

import ServiceTile from './ServiceTile';
import { useServer } from '../Server/ServerContext';
import Subtitle from '../AppHeadBar/Subtitle';
import appFunctions from '../../AppFunctions';

import { Styles } from '../../Types';

const styles = {
  servicesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: (theme) => theme.spacing(1),
    paddingTop: (theme) => theme.spacing(6),
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
    position: 'relative',
    zIndex: 1,
  },
  description: {
    marginTop: (theme) => theme.spacing(-2),
    padding: (theme) => `${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(2)}`,
    whiteSpace: 'pre-line',
    overflowWrap: 'anywhere',
    // don't let the text contribute to the intrinsic width of the dialog,
    // only fill the width the services already take up
    width: 0,
    minWidth: '100%',
    boxSizing: 'border-box',
    color: (theme) => theme.palette.text.secondary,
  },
} as Styles;

export default function ServicesWrapper() {
  const { category } = appFunctions.getSelection(useServer());

  return (
    <>
      <Subtitle>{category.name}</Subtitle>

      <Box sx={styles.servicesWrapper}>
        {category.description && (
          <Typography variant="body1" sx={styles.description}>
            {category.description}
          </Typography>
        )}
        {category.services.map((service) => (
          <ServiceTile service={service} key={service.id} />
        ))}
      </Box>
    </>
  );
}
